export default __webpack_public_path__ + "static/media/47.55d06ab9.svg";